import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
// import config from '../../config'
// import format from '../../helpers/format'
import {
  Grade
} from '../'
import Styles from './FundSjfReportCardNav.css'


@CSSModules(Styles, {allowMultiple:true})
class FundSjfReportCardNavItem extends Component {
  static propTypes = {
    clickFn: PropTypes.func.isRequired,
    i: PropTypes.number.isRequired,
    e: PropTypes.array.isRequired,
  }
  constructor(props){
    super(props)
    this.state = {}
  }
  render() {
    return <button
      styleName='fund-report-card-nav-item'
      onClick={ () => { this.props.clickFn(this.props.e[1]) } }
      key={'FundSjfReportCardNavItem-'+this.props.i}
    >
      <div styleName='fund-report-card-nav-item__label'>
        {this.props.e[0]}
      </div>
      <div styleName='fund-report-card-nav-item__grade'>
        <Grade grade={this.props.e[2]} square/>
      </div>
    </button>
  }
}


@CSSModules(Styles, {allowMultiple:true})
export default class FundSjfReportCardNav extends Component {
  static propTypes = {
    clickTabFn: PropTypes.func,
    clickTab2Fn: PropTypes.func,
    gradeGef: PropTypes.number,
    gradeDei: PropTypes.number,
    gradeRji: PropTypes.number,
    gradeHrc: PropTypes.number,
    gradePff: PropTypes.number,
  }
  //
  constructor(props){
    super(props)
    this.state = {
      sjfConfig: [
        ['Gender Equality', 'gef', props.gradeGef],
        ['Diversity Disclosures', 'dei', props.gradeDei],
        ['Racial Justice', 'rji', props.gradeRji],
        ['LGBTQ+ Equity', 'hrc', props.gradeHrc],
      ],
      exclusionsConfig: [
        ['Prisons & Borders', 'pff', props.gradePff],
        ['Military Weapons', 'wff', props.gradeWff],
      ]
    }
  }
  //
  render() {
    return <div styleName='fund-report-card-nav'>
      <div styleName='fund-report-card-nav__grades'>
        <h3>
          Equity & Justice
        </h3>
        {
          this.state.sjfConfig.map((e, i)=>{
            return <FundSjfReportCardNavItem
              clickFn={this.props.clickTabFn} i={i} e={e}
              key={'FundSjfReportCardNavItem-ej-'+i}
            />
          })
        }
      </div>
      <div styleName='fund-report-card-nav__grades'>
        <h3>
          Exclusions
        </h3>
        {
          this.state.exclusionsConfig.map((e, i)=>{
            return <FundSjfReportCardNavItem
              clickFn={this.props.clickTab2Fn} i={i} e={e}
              key={'FundSjfReportCardNavItem-ex-'+i}
            />
          })
        }
      </div>
    </div>
  }
}